import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { USER_ROLES, AppConsts } from "@shared/app-consts";
import { AuthenticationService } from "@services/security";
import { environment } from "@environment";
import { PortageService } from "@services/portage.service";
import { ApiPortageParameters } from "@shared/models/api-portage-parameters";

@Component({
  selector: "app-side-menu",
  templateUrl: "./side-menu-v2.component.html",
  styleUrls: ["./side-menu.component.css"],
  standalone: false
})
export class SideMenuComponent implements OnInit {
  currentUserEmail: string;
  showBankModule: boolean = false;
  isExternalLogin: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter();
  readonly USER_ROLES = USER_ROLES;
  production:boolean = AppConsts.IS_ENV_PRODUCTION;
  parameters: ApiPortageParameters;

  constructor(private authService: AuthenticationService,private gestionPortageSalarialService:PortageService) {}

  ngOnInit() {
    this.authService.authenticationState.subscribe(() => {
      var jwtToken = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
      this.currentUserEmail = jwtToken == null ? '' : jwtToken.UserEMail;
      this.showBankModule = (this.currentUserEmail == 'azedkalda@gmail.com') || (this.currentUserEmail == 'a.kalda@fiparco.fr');
    });

    this.authService.externalUserInfo.subscribe(info => {
      this.isExternalLogin = info.isExternal;
    });
   // this.getApiPortageParameters();
  }
//  getApiPortageParameters()
//   {

//     this.gestionPortageSalarialService.getApiPortageParameters().subscribe((res:ApiPortageParameters) => {
//       this.parameters=res;
//          });
//   }
  closeMenu() {
    this.close.emit();
  }

  isProduction() {
    return AppConsts.IS_ENV_PRODUCTION;
  }

}
